import axios from "axios";
import React, { useState } from "react";
import { headers } from "../../../exports/exports";
import { failed, success } from "../../../hooks/useToast";
import { IMemberListData } from "../../../exports/interfaces";
import { useLoader } from "../../../context/LoaderContext";
import DynamicToolTip from "../../DynamicToolTip";
import DeletePopUp from "../../DeletePopUp";

type UploadData = {
  [key: string]: {
    data: {
      id: number;
      attributes: {
        name: string;
        ext: string;
        url: string;
      };
    };
  };
};

const Uploads = (props: {
  listMemberData: IMemberListData[];
  memberId: number;
  getUserById: () => void;
}) => {
  const { setLoading } = useLoader();

  const [selectedFiles, setSelectedFiles] = useState<{ [key: number]: File }>(
    {}
  );
  const [open, setOpen] = useState(false);
  const [fieldName, setFieldName] = useState<string>("");

  const uploadList: UploadData =
    props?.listMemberData[0]?.attributes?.bi_frcsit_user_upload?.data
      ?.attributes;
  const uploadFields = [
    {
      id: 1,
      label: "Photograph",
      types: "png, jpg, jpeg",
      name: "Photograph",
    },
    {
      id: 2,
      label: "Bachelor Degree",
      types: "png, jpg, jpeg, pdf",
      name: "Bachelor_Degree",
    },
    {
      id: 3,
      label: "Master Degree",
      types: "png, jpg, jpeg, pdf",
      name: "Master_Degree",
    },
    {
      id: 4,
      label: "MCI/State council registration",
      types: "png, jpg, jpeg, pdf",
      name: "MCI",
    },
    {
      id: 5,
      label: "Photo ID (Aadhar/Driving License/Voter ID/Passport)",
      types: "png, jpg, jpeg",
      name: "Photo_ID",
    },
    {
      id: 6,
      label: "Curriculum Vitae",
      types: "pdf",
      name: "Curriculum_Vitae",
    },
  ];

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedFiles((prev) => ({
        ...prev,
        [id]: file,
      }));
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const uploadedFileIds: { [key: number]: number } = {};

      for (const id in selectedFiles) {
        const file = selectedFiles[Number(id)];
        const formData = new FormData();
        formData.append("files", file);

        const uploadRes = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/upload`,
          formData,
          {
            headers: {
              Authorization: headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const uploadedId = uploadRes.data[0].id;
        uploadedFileIds[Number(id)] = uploadedId;
      }

      const updatePayload = {
        data: {
          Photograph: uploadedFileIds[1],
          Bachelor_Degree: uploadedFileIds[2],
          Master_Degree: uploadedFileIds[3],
          MCI: uploadedFileIds[4],
          Photo_ID: uploadedFileIds[5],
          Curriculum_Vitae: uploadedFileIds[6],
          be_frcsit_user: props.memberId,
        },
      };

      if (!uploadList) {
        const userRes = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads`,
          updatePayload,
          {
            headers,
          }
        );

        if (userRes?.status === 200 || userRes?.status === 201) {
          props.getUserById();
          success();
          setSelectedFiles({});
          setLoading(false);
        }
      } else {
        const userRes = await axios.put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads/${props?.listMemberData[0]?.attributes?.bi_frcsit_user_upload?.data?.id}`,
          updatePayload,
          {
            headers,
          }
        );

        if (userRes?.status === 200 || userRes?.status === 201) {
          props.getUserById();
          success();
          setSelectedFiles({});
          setLoading(false);
        }
      }
    } catch (error) {
      failed();
      setLoading(false);
    }
  };
  const handleDelete = async (fieldName: string) => {
    setLoading(true);
    try {
      const fileId = uploadList?.[fieldName]?.data?.id;
      await axios.delete(
        `${process.env.REACT_APP_strapiUrl}/api/upload/files/${fileId}`,
        { headers }
      );

      const uploadEntryId =
        props?.listMemberData[0]?.attributes?.bi_frcsit_user_upload?.data?.id;

      await axios.put(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads/${uploadEntryId}`,
        {
          data: {
            [fieldName]: null,
          },
        },
        { headers }
      );

      success();
      props.getUserById();
      setLoading(false);
    } catch (error) {
      failed();
      setLoading(false);
    }
  };

  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Uploads</h3>
        </div>
      </div>
      <hr />
      {uploadFields.map((field) => {
        const fileData = uploadList?.[field.name]?.data;

        return (
          <div className="upload-item" key={field.id}>
            <div className="upload-label">
              <p className="upload-title">
                <strong>
                  {field.id}. {field.label}
                </strong>
                <p className="upload-subtext">
                  Allowed file types: {field.types}
                </p>
              </p>
            </div>

            <div className="col-xl-4">
              {fileData ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <a
                    href={`${process.env.REACT_APP_strapiUrl}${fileData.attributes.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    // className="view-link"
                  >
                    <DynamicToolTip title="View">
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        <span className="icon-eye"></span>
                      </button>
                    </DynamicToolTip>
                  </a>
                  <DynamicToolTip title="Delete">
                    <button
                      onClick={() => {
                        setOpen(true);
                        setFieldName(field.name);
                      }}
                      style={{
                        backgroundColor: "transparent",
                        color: "red",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <span className="icon-bin"></span>
                    </button>
                  </DynamicToolTip>
                </div>
              ) : (
                <div className="become-volunteer__input custom-file-input">
                  <label htmlFor={`file-upload-${field.id}`}>
                    {selectedFiles[field.id]?.name || "Upload File"}
                  </label>
                  <input
                    type="file"
                    id={`file-upload-${field.id}`}
                    name={`file-upload-${field.id}`}
                    accept={field.types
                      .split(",")
                      .map((type) => `.${type.trim()}`)
                      .join(",")}
                    onChange={(e) => handleFileChange(e, field.id)}
                  />
                </div>
              )}
            </div>
          </div>
        );
      })}
      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
      <DeletePopUp
        open={open}
        setOpen={setOpen}
        onDelete={() => handleDelete(fieldName)}
      />
    </>
  );
};

export default Uploads;
